import request from '@/utils/request'


// 查询短剧统计列表
export function listStatistics(query) {
  return request({
    url: '/video/video-statistics/list',
    method: 'get',
    params: query
  })
}

// 统计短剧数据分页列表
export function statistics(query) {
  return request({
    url: '/video/video-statistics/statistics',
    method: 'get',
    params: query
  })
}

// 查询短剧统计分页
export function pageStatistics(query) {
  return request({
    url: '/video/video-statistics/page',
    method: 'get',
    params: query
  })
}

// 查询短剧统计详细
export function getStatistics(data) {
  return request({
    url: '/video/video-statistics/detail',
    method: 'get',
    params: data
  })
}

// 新增短剧统计
export function addStatistics(data) {
  return request({
    url: '/video/video-statistics/add',
    method: 'post',
    data: data
  })
}

// 修改短剧统计
export function updateStatistics(data) {
  return request({
    url: '/video/video-statistics/edit',
    method: 'post',
    data: data
  })
}

// 删除短剧统计
export function delStatistics(data) {
  return request({
    url: '/video/video-statistics/delete',
    method: 'post',
    data: data
  })
}
